<textarea
  #inputEl
  [formControl]="myFormControl"
  [minlength]="question.minLength"
  [maxlength]="question.maxLength"
  (focus)="isFocused = true"
  (blur)="onBlur()"
  id="{{ 'question-input-' + question.id }}"
  [attr.disabled]="disabled"
  [attr.tabindex]="tabIndex"
></textarea>

@if (myFormControl?.errors) {
<div class="clear validation-text">
  @if (myFormControl?.errors?.required) {
  <div>{{ question.question }} {{ "is-required" | transloco }}</div>
  } @if (myFormControl?.errors?.minlength) {
  <div>
    {{ question.question }} {{ "must-be-at-least" | transloco }}
    {{ myFormControl?.errors?.minlength.requiredLength }}
    {{ "characters" | transloco }}
  </div>
  }
</div>
} @if ( myFormControl.value && question.maxLength && myFormControl?.errors ===
null && isFocused ) {
<div
  class="char-count"
  [ngClass]="{ invalid: myFormControl.value.length >= question.maxLength }"
>
  {{ question.maxLength - myFormControl.value.length }}
  {{ "chars-left" | transloco }}
</div>
}
